module.exports = __webpack_public_path__ + "img/hr_bg.10df7e11.jpg";